import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommThreeDotsHorizontalIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20 12.75C19.5858 12.75 19.25 12.4142 19.25 12 19.25 11.5858 19.5858 11.25 20 11.25 20.4142 11.25 20.75 11.5858 20.75 12 20.75 12.4142 20.4142 12.75 20 12.75zM17.75 12C17.75 13.2426 18.7574 14.25 20 14.25 21.2426 14.25 22.25 13.2426 22.25 12 22.25 10.7574 21.2426 9.75 20 9.75 18.7574 9.75 17.75 10.7574 17.75 12zM12.5 12.75C12.0858 12.75 11.75 12.4142 11.75 12 11.75 11.5858 12.0858 11.25 12.5 11.25 12.9142 11.25 13.25 11.5858 13.25 12 13.25 12.4142 12.9142 12.75 12.5 12.75zM10.25 12C10.25 13.2426 11.2574 14.25 12.5 14.25 13.7426 14.25 14.75 13.2426 14.75 12 14.75 10.7574 13.7426 9.75 12.5 9.75 11.2574 9.75 10.25 10.7574 10.25 12zM5 12.75C4.58579 12.75 4.25 12.4142 4.25 12 4.25 11.5858 4.58579 11.25 5 11.25 5.41421 11.25 5.75 11.5858 5.75 12 5.75 12.4142 5.41421 12.75 5 12.75zM2.75 12C2.75 13.2426 3.75736 14.25 5 14.25 6.24264 14.25 7.25 13.2426 7.25 12 7.25 10.7574 6.24264 9.75 5 9.75 3.75736 9.75 2.75 10.7574 2.75 12z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
